<template>
  <div>
    <div class="fw-bold mb-3">{{ content }}</div>
    <div
      v-for="(option, idx) in optionsShuffled"
      :key="option"
      :class="{ 'mb-3': idx < optionsShuffled.length - 1 }"
    >
      <button
        type="button"
        class="btn fw-bold w-100 fs-5 d-flex justify-content-between text-start shadow-sm"
        :class="{
          'btn-dark':
            !isSubmitted &&
            selectedAnswer === option &&
            formInputValue !== option,
          'btn-success  disabled':
            (isSubmitted && isCorrect) || formInputValue === option,
          'btn-danger': isSubmitted && !isCorrect,
          'btn-light text-dark border-dark':
            !selectedAnswer || selectedAnswer !== option
        }"
        :disabled="(formInputValue && formInputValue != option) || isReport"
        @click="checkAnswer(option)"
      >
        {{ option }}
        <i
          class="bi"
          :class="{
            'bi-x-circle':
              isSubmitted && !isCorrect && selectedAnswer === option,
            'bi-check-circle': isCorrect && selectedAnswer === option
          }"
        ></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormSelect",
  components: {},
  data() {
    return {
      selectedAnswer: null
    };
  },
  props: {
    id: String,
    content: {
      type: String,
      default: "Form Select Content"
    },
    options: Array,
    isCorrect: Boolean,
    isSubmitted: Boolean,
    formInputValue: String,
    shuffle: Boolean,
    isReport: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ["updateFormValue"],
  computed: {
    // Shuffle options if shuffle prop is true
    optionsShuffled() {
      if (!this.shuffle) {
        return this.options; // no shuffle, just return original
      }

      // Check if a shuffle already exists for this step
      const saved = localStorage.getItem(`shuffle-${this.id}`);

      // Remove saved shuffle if input is empty
      if (this.formInputValue === null || this.formInputValue === "") {
        localStorage.removeItem(`shuffle-${this.id}`);
        // If not, shuffle using Fisher-Yates
        const array = this.options.slice(); // copy
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }

        // Save the shuffled array for next time
        localStorage.setItem(`shuffle-${this.id}`, JSON.stringify(array));

        return array;
      }

      if (saved) {
        return JSON.parse(saved);
      }

      return this.options; // fallback
    }
  },
  methods: {
    checkAnswer(option) {
      this.selectedAnswer = option;

      this.$emit("updateFormValue", option);
    }
  },
  mounted() {
    // Initialize selected answer with formInputValue when component mounts
    this.selectedAnswer = this.formInputValue;
  }
  /* lifecycle hooks */
};
</script>
